var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAcorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6845 10.6364C17.741 9.74444 14.8213 7.71473 11.4089 7.80049C8.93455 7.86338 6.46574 8.70957 4.26414 10.5735C3.95797 9.36136 3.5516 6.9057 5.41086 5.71647C7.36197 4.47005 10.6101 4.43289 10.6101 4.43289L10.6212 3.5381C10.6212 3.5381 9.83635 3.52667 9.71945 3.52381C8.9429 3.51238 8.7091 1.98581 9.74171 2.0001C9.98664 2.00296 12.2523 2.04012 13.2654 2.05442C14.4066 2.07157 14.1143 3.58956 13.2431 3.57813C12.8952 3.57241 12.3553 3.56383 12.3553 3.56383L12.3497 4.46148C12.3497 4.46148 17.4988 4.38715 18.6762 6.96002C19.2551 8.20929 18.9295 9.95312 18.6845 10.6364Z",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89138 20.5619C8.81897 21.3057 9.96062 21.8223 11.3506 22.0012C18.6343 20.9338 18.543 12.1727 18.543 12.1727C18.543 12.1727 16.1712 9.38773 11.6874 9.27701C8.64202 9.20036 5.86209 10.5631 4.45215 11.9627C4.47213 13.3367 4.66906 14.7903 5.09433 16.1558",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27295 18.8164C6.55267 19.1365 6.85707 19.4406 7.18204 19.7255",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36475 17C5.50026 17.3127 5.6499 17.6148 5.81929 17.9091",
    stroke: "#485058",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAcorn);
export default __webpack_public_path__ + "static/media/ic_acorn.a2fa4e94981dbe699dfb424a33d29c63.svg";
export { ForwardRef as ReactComponent };